import { component as defineComponent } from 'flightjs';

export default defineComponent(function() {
    this.attributes({
        container: '[data-description-slider-content-container]',
        trigger: '[data-description-slider-trigger]',
        more: '[data-description-slider-trigger][data-more-text]',
        less: '[data-description-slider-trigger][data-less-text]',
    });

    this.toggle = function(e) {
        e.preventDefault();
        this.select('container').slideToggle();
        this.toggleElement(this.select('more'));
        this.toggleElement(this.select('less'));
    };

    this.toggleElement = function(element) {
        if (typeof element.attr('data-hidden') === 'undefined') {
            element.attr('data-hidden', true);
        } else {
            element.removeAttr('data-hidden');
        }
    };

    this.after('initialize', function() {
        this.select('trigger').on('click', this.toggle.bind(this));
    });
});



// WEBPACK FOOTER //
// ./src/web/js/polls/modules/vote-description-slider.js